export const NOTIFICATION_STATUS_LABELS = {
  pending: 'Ожидает',
  in_progress: 'В процессе',
  completed: 'Завершена',
  failed: 'Ошибка',
  canceled: 'Отменена',
  test_sent: 'Тест отправлен'
};

export const getNotificationStatusLabel = (status) => {
  if (!status) {
    return 'Не запущена';
  }

  return NOTIFICATION_STATUS_LABELS[status] || status;
};

export const normalizeNotificationStatusPayload = (payload = {}) => {
  const campaign = payload?.data ?? payload ?? {};
  const sentCount = campaign.sentCount ?? 0;
  const failedCount = campaign.failedCount ?? 0;
  const totalRecipients = campaign.totalRecipients ?? 0;
  const processedCount = campaign.processedCount ?? (sentCount + failedCount);
  const remainingCount = campaign.remainingCount ?? Math.max(totalRecipients - processedCount, 0);

  return {
    ...campaign,
    sentCount,
    failedCount,
    totalRecipients,
    processedCount,
    remainingCount,
    lastError: campaign.lastError ?? null
  };
};
